import React from 'react';
import Styles from './alert-message-styles.scss';
import { InformationSquare } from '../icons';
const AlertMessage = ({ message, background = '#ebf4ff', fontSize = '15px', noIcon = false }) => {
    return (React.createElement("div", { className: Styles.alertMessageWrap, style: { background: background } },
        !noIcon && (React.createElement("div", { className: Styles.logo },
            React.createElement(InformationSquare, { width: 24, height: 24 }))),
        React.createElement("div", { className: Styles.text },
            React.createElement("h4", { style: { fontSize: fontSize } }, message))));
};
export default AlertMessage;
